/* page */
/*--------------------------------------------------------------------------------*/
const app = document.querySelector<HTMLElement>('#app');
const pageSpin: string = /*html*/ `
<div class="lds-spinner">
    <div></div><div></div><div></div><div></div>
    <div></div><div></div><div></div><div></div>
    <div></div><div></div><div></div><div></div>
</div>
`;
const smallSpin: string = `<div class="spinner s32"></div>`;
/*--------------------------------------------------------------------------------*/
export const loading = (size = 'default') => {
    if (!app) return;
    // page-loader
    if (!app.querySelector('#page-loader')) {
        const loader = document.createElement('div');
        loader.id = 'page-loader';
        loader.className = 'overlay center';
        loader.innerHTML = size == 'default' ? pageSpin : smallSpin;
        app.appendChild(loader);
    }
    // app-content
    const content = app.querySelector<HTMLElement>('#app-content');
    if (content) content.style.display = 'none';
};
/*--------------------------------------------------------------------------------*/
export const ready = (delay = 400) => {
    new Promise(r => setTimeout(r, delay)).then(() => {
        clearLoader(true);
    });
};
/*--------------------------------------------------------------------------------*/
export const error = (err: Error) => {
    clearLoader(false);
    if (!app) return;
    // create
    const box = document.createElement('div');
    box.className = 'page-error';
    box.innerHTML = /*html*/ `
        <i class="icon red">&#xf188;</i>
        <div class="topic">&#x2726; เกิดข้อผิดพลาด &#x2726;</div>
        <div class="text">${err}</div>
    `;
    app.prepend(box);
    throw err;
};
/*--------------------------------------------------------------------------------*/
export const notFound = () => {
    if (!app) return;
    app.innerHTML = /*html*/ `
        <div class="page-not-found">
            <h1>4<i class="fas fa-ghost"></i>4</h1>
            <h2>Error 404 Page Not Found</h2>
            <p>Sorry, the page cannot be accessed</p>
        </div>
    `;
};
/*--------------------------------------------------------------------------------*/
export const fullLoad = () => {
    clearNavbar();
    if (!app) return;
    app.classList.add('full-page');
    app.innerHTML = /*html*/ `
        <div class="page-full-load">
            <div class="spinner"></div>
            <div class="text">Slim<br>Loading</div>
        </div>
    `;
};
/*--------------------------------------------------------------------------------*/
export const inform = (params: {
    icon: string;
    msg: string;
    btnTxt: string;
    btnUrl: string;
    color?: string;
}) => {
    clearNavbar();
    if (!app) return;
    app.classList.add('full-page');
    app.innerHTML = /*html*/ `
        <div class="page-inform ${params.color}">
            <div class="icon solid">${params.icon}</div>
            <div class="msg">${params.msg}</div>
            <button class="lg ${params.color}" shadow="true">
                ${params.btnTxt}
            </button>
        </div>
    `;
    const btn = app.querySelector<HTMLButtonElement>('button')!;
    btn.onclick = () => window.location.replace(params.btnUrl);
};
/*--------------------------------------------------------------------------------*/
//export const Maintain = () => { };
//export const Construct = () => { };
/*--------------------------------------------------------------------------------*/
const clearNavbar = () => {
    const topbar = document.querySelector<HTMLElement>('#topbar');
    const tabbar = document.querySelector<HTMLElement>('#tabbar');
    const sidebar = document.querySelector<HTMLElement>('#sidebar');
    if (topbar) topbar.remove();
    if (tabbar) tabbar.remove();
    if (sidebar) sidebar.remove();
    if (app) app.className = '';
};
const clearLoader = (showContent: boolean) => {
    if (!app) return;
    const loader = app.querySelector<HTMLElement>('#page-loader');
    if (loader) {
        loader.style.animation = 'fade-out 0.4s forwards';
        loader.onanimationend = () => loader.remove();
    }
    const content = app.querySelector<HTMLElement>('#app-content');
    if (content) content.style.display = showContent ? 'block' : 'none';
};
/*--------------------------------------------------------------------------------*/
